import * as React from 'react';
import { ActivityIndicator } from '../../SharedComponents/ActivityIndicator';

export enum OnboardingPages {
    CreateStory,
    AddPhotos,
    AddPhotoMeta,
}

interface IProps {
    activePage: OnboardingPages
}

export class OnboardingActivityIndicator extends React.Component<IProps> {
    public render(): React.ReactNode {
        const pageCount = Object.entries(OnboardingPages).length / 2; // Enums have both forward and reverse entries.
        return <ActivityIndicator containerStyle={{
            ...styles.activityIndicator,
            width: pageCount * 15
        }} currentStep={this.props.activePage} maxSteps={pageCount - 1}/>;
    }
}

const styles: Record<string, React.CSSProperties> = {
    activityIndicator: {
        height: 15,
        marginTop: 35,
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnBoardingNav.tsx